import { StudioConfig } from "../types";

/**
 * JA (18-08-23)
 * Identify the applicable format for the selected ad size.
 */
export const applicableFormatsForAdSize = (studioConfig: StudioConfig, selectedAdSize: string) =>
  Object.keys(studioConfig.formats)
    .filter((key) => studioConfig.formats[key].media.frameRatios.some((option: FrameRatio) => option.adSize === selectedAdSize))
    .map((key) => key);
